import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./ArticleValue.scss";

import RangeBar from "../ui/rangeBar/RangeBar";
import { CircleLoader } from "../../icons/Loaders";


const ArticleValue = () => {

    const numbers = useSelector((state: any) => state.activeFeedItem.numbersData) || {};
    const {articleValueSettings, customMetrics} = useSelector((state: any) => state.currentBrand.data) || {};
    const isLoadingNumbers = useSelector((state : any) => state.activeFeedItem.isLoadingNumbers);
    const isLoadingCurrentBrand = useSelector((state : any) => state.currentBrand.isLoading);

    const calculateColorClass = (index) => {
        if ((index + 1) % 3 === 0) {
            return "cyan";
        } else if ((index + 1) % 2 === 0) {
            return "purple";
        } else {
            return "pink";
        }
    }

    const prepareValueData = (section) => {
        let value, min, max = 0;

        const dividedMainPath = section.path.split(".");
        if (dividedMainPath.length === 1) {
            value = numbers?.[dividedMainPath[0]] || 0;
        } else {
            value = numbers?.[dividedMainPath[0]]?.[dividedMainPath[1]] || 0
        }

        const dividedMinPath = section.minPath.split(".");
        if (dividedMinPath.length === 1) {
            min = numbers?.[dividedMinPath[0]] || 0;
        } else {
            min = numbers?.[dividedMinPath[0]]?.[dividedMinPath[1]] || 0
        }

        const dividedMaxPath = section.maxPath.split(".");
        if (dividedMaxPath.length === 1) {
            max = numbers?.[dividedMaxPath[0]] || 0;
        } else {
            max = numbers?.[dividedMaxPath[0]]?.[dividedMaxPath[1]] || 0
        }

        return {
            value, min, max
        }
    }

    const formatTime = (value) => {
        const minutes = Math.trunc(value/60);
        const seconds = value%60;

        if (seconds < 10) {
            return `${minutes}:0${seconds}`;
        } else {
            return `${minutes}:${seconds}`
        }
    }

    const resolveSubSectionValue = (path, format) => {
        const pathDivided = path.split(".");
        let value = 0;
        if (pathDivided.length === 1) {
            value = numbers?.[pathDivided[0]] || 0;
        } else {
            value = numbers?.[pathDivided[0]]?.[pathDivided[1]];
        }
        switch (format) {
            case "number" : return value;
            case "percentage" : return value + "%";
            case "time(m:ss)" : return formatTime(value);
            case "time" : return value; 
            default: return value;
        }
    }

    const resolveTotalValue = (path) => {
        const pathDivided = path.split(".");
        if (pathDivided.length === 1) {
            return numbers?.[pathDivided[0]] || 0
        } else return numbers?.[pathDivided[0]]?.[pathDivided[1]] || 0
    }


    if (isLoadingCurrentBrand || isLoadingNumbers) return <div className="article-value-loader-container">
        <CircleLoader/>
    </div>

    if (!articleValueSettings || articleValueSettings === undefined || 
        (typeof articleValueSettings === 'object' && Object.keys(articleValueSettings).length === 0)) return <></>


    return <div className="article-value-container">
        <div className="total-score"> 
            <h4 className="total-score-label">Article value</h4>
            <div className="total-score-value">{resolveTotalValue(articleValueSettings?.totalScorePath)}</div>
        </div>
        <div className="article-value-range-bars">
            {articleValueSettings.sections.map(((section,i) => {
                return <RangeBar 
                    colorClass={calculateColorClass(i)} 
                    title={section.label} 
                    configData={{
                        minRange : section.minRange,
                        maxRange : section.maxRange
                    }}
                    valueData={prepareValueData(section)}
                    key={section.label}
                    />
            }))}
        </div>

        <div className="article-value-numbers">
            <div className="labels">
                {
                    articleValueSettings.sections.map((section, i) => {
                        return <div className={`subsection-values-container labels ${calculateColorClass(i)}`} key={section.label}>
                            {section.subSections.map((subSec) => {
                                return <div className="" key={subSec.label}>{subSec.label}</div>
                            })}
                        </div>
                    })
                }
            </div>
             <div className="values">
                {
                    articleValueSettings.sections.map((section, i) => {
                        return <div className={`subsection-values-container values ${calculateColorClass(i)}`} key={section.label}>
                            {section.subSections.map((subSec) => {
                                return <div className="value" key={subSec.path}>{resolveSubSectionValue(subSec.path, subSec.format)}</div>
                            })}
                        </div>
                    })
                }
            </div>
        </div>
    </div>
}


export default ArticleValue;